export const getPositionInPercentage = (position = 0, durationInSeconds = 0): number =>
  position && durationInSeconds ? (position / durationInSeconds) * 100 : 0;

export const isVideoCompleted = (position: number | null = 0, durationInSeconds: number | null = 0): boolean => {
  if (position === null || durationInSeconds === null) {
    return false;
  }

  const durationInMinutes: number = Math.round(durationInSeconds / 60);
  return durationInMinutes > 20
    ? position >= durationInSeconds - 60
    : +getPositionInPercentage(position, durationInSeconds).toFixed(2) >= 95;
};
